/* ==============================================
   CRO Accordion — Charu Perfumery House
   Managed via CLI. Do NOT edit in Shopify admin.
   ============================================== */
(function () {
  function openBody(body) {
    body.style.maxHeight = body.scrollHeight + 'px';
  }

  function closeBody(body) {
    body.style.maxHeight = '0';
  }

  function initAccordion(el) {
    var trigger = el.querySelector('.desc-accordion__trigger');
    var body    = el.querySelector('.desc-accordion__body');
    if (!trigger || !body) return;

    var openByDefault = el.dataset.openByDefault === 'true';
    if (openByDefault) {
      trigger.setAttribute('aria-expanded', 'true');
      body.classList.add('is-open');
      openBody(body);
    }

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      body.classList.toggle('is-open', !isOpen);
      if (!isOpen) {
        openBody(body);
      } else {
        closeBody(body);
      }
    });
  }

  document.querySelectorAll('[data-accordion]').forEach(initAccordion);
})();
